import { render, staticRenderFns } from "./CrudForm.vue?vue&type=template&id=796a2bf4&"
import script from "./CrudForm.vue?vue&type=script&lang=js&"
export * from "./CrudForm.vue?vue&type=script&lang=js&"
import style0 from "./CrudForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports